import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardImg,
  Col,
  Container,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { imageBaseApi } from "../../../utilis/imageHelper";
import DeleteModal from "../../../Components/Common/DeleteModal";
import InstituteWidgetService from "../../../services/KangarooServices/Intelligence/InstituteWidgetService";
import InstituteWidgetForm from "../component/InstituteWidgetForm";
import toast from "react-hot-toast";

const InstituteWidget = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [isAssignModalOpen, setIsAssignModalOpen] = useState(false);
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const [isMain, setIsMain] = useState(false);

  const toggleWidget = (item) => {
    setSelectedItem(item);
    setIsWidgetOpen(!isWidgetOpen);
  };
  const toggleModal = (item) => {
    setSelectedItem(item);
    setIsModalOpen(!isModalOpen);
  };
  const toggleAssignModal = (item) => {
    setSelectedItem(item);
    setIsAssignModalOpen(!isAssignModalOpen);
  };
  const [data, setData] = useState([]);
  const fetchData = async () => {
    try {
      const response = await InstituteWidgetService.getList();
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    if (item?.universityId) {
      setIsMain(true);
    } else {
      setIsMain(false);
    }
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        if (isMain === true) {
          await InstituteWidgetService.deleteMain(
            selectedDeleteItem?.universityId,
          );
        } else {
          await InstituteWidgetService.delete(selectedDeleteItem);
        }
        fetchData();
        toast.success("Selected item deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Institute Widgets" pageTitle="Widget Setup" />

        <Row className="mb-3">
          <div className="d-flex justify-content-between align-items-center ">
            <button className="btn btn-success" onClick={toggleWidget}>
              <i className="bi bi-plus-lg"></i> Add Widget
            </button>
          </div>{" "}
        </Row>

        <Row xs="1" md="2" lg="3" className="g-4">
          {data?.map((university) => (
            <Col key={university.universityId}>
              <Card className="h-100 shadow-sm border-0 widget-card">
                {/* Header */}
                <div className="card-header bg-light border-0 d-flex justify-content-between align-items-center">
                  <h6 className="mb-0 fw-semibold">
                    🎓 {university.universityName}
                  </h6>
                  <span className="badge bg-primary">
                    {university.widgets?.length} Widget
                    {university.widgets?.length > 1 ? "s" : ""}
                  </span>
                </div>

                {/* Body */}
                <CardBody>
                  {university.widgets?.length > 0 ? (
                    university.widgets.map((widget) => (
                      <div
                        key={widget.id}
                        className="d-flex gap-3 align-items-start mb-3 rounded widget-item p-2"
                        style={{ background: "#f9f9f9" }}
                      >
                        {/* Image */}
                        {widget.image?.url && (
                          <img
                            src={`${imageBaseApi}${widget.image.url}`}
                            alt={widget.name}
                            className="rounded"
                            width="55"
                            height="55"
                            style={{ objectFit: "contain" }}
                          />
                        )}

                        {/* Content */}
                        <div className="flex-grow-1">
                          <p className="mb-1 fw-medium">{widget.name}</p>
                          <small className="text-muted">
                            {widget.headingName}
                          </small>
                          <div
                            style={{ fontSize: "0.8rem" }}
                            dangerouslySetInnerHTML={{
                              __html: widget.description,
                            }}
                          />
                        </div>
                        <div>
                          <Button
                            size="sm"
                            color="danger"
                            outline
                            onClick={() => handleDeleteClick(widget?.id)}
                          >
                            <i className="ri-delete-bin-5-line"></i>
                          </Button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-muted text-center mb-0">
                      No widgets available
                    </p>
                  )}
                </CardBody>

                {/* Footer */}
                <CardFooter className="bg-white border-0 pt-0">
                  <div className="d-flex justify-content-end gap-2">
                    <Button
                      size="sm"
                      color="warning"
                      outline
                      onClick={() => toggleWidget(university)}
                    >
                      <i className="ri-edit-line"></i>
                    </Button>
                    {/* <Button
                      size="sm"
                      color="info"
                      outline
                      onClick={() =>
                        navigate(`/institute-widget/${university.universityId}`)
                      }
                      title="View country widgets"
                    >
                      <i className="ri-eye-line"></i>
                    </Button> */}
                    <Button
                      size="sm"
                      color="danger"
                      outline
                      onClick={() => handleDeleteClick(university)}
                    >
                      <i className="ri-delete-bin-5-line"></i>
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            </Col>
          ))}
        </Row>

        <InstituteWidgetForm
          isOpen={isWidgetOpen}
          toggle={toggleWidget}
          selectedItem={selectedItem}
          fetchData={fetchData}
        />
        <DeleteModal
          show={isOpenDelete}
          onCloseClick={toggleDelete}
          onDeleteClick={handleDelete}
        />
      </Container>
    </div>
  );
};

export default InstituteWidget;
